import moment from "moment";
import { ref, watch } from "vue";
import { useTrackStore } from "@/stores/TrackStore.js";
import { storeToRefs } from "pinia";

class AudioPlayer {
  constructor() {
    this.progressRatio = ref(0);
    this.progressTime = ref(null);
    this.canPlay = ref(false);
    this.playing = ref(false);
    this.audio = new Audio();
    this.audio.addEventListener("ended", this.onEnded.bind(this));
    this.audio.addEventListener("timeupdate", this.onTimeupdate.bind(this));
    this.setupObservers();
  }

  setupObservers() {
    const { playingTrack } = storeToRefs(useTrackStore());
    watch(playingTrack, (track) => {
      if (track) {
        this.setTrack(track);
      }
    });
  }

  stop() {
    if (!this.audio.src) return;

    this.audio.pause();
    this.audio.currentTime = 0;
    this.progressRatio.value = 0;
    this.playing.value = false;
    this.audio.dispatchEvent(new Event("timeupdate"));
  }

  toggle() {
    if (!this.audio.src) return;

    if (this.audio.paused) {
      this.audio.play();
      this.playing.value = true;
    } else {
      this.audio.pause();
      this.playing.value = false;
    }
  }

  setTrack(track) {
    this.audio.src = track.trackFileUrl;
    this.audio.load();
    this.audio.play();
    this.canPlay.value = true;
    this.playing.value = true;
  }

  seekTo(targetProgress) {
    console.log("seekTo", targetProgress);
    this.audio.currentTime = targetProgress * this.audio.duration;
    this.progressRatio.value = targetProgress;
  }

  onTimeupdate() {
    const current = moment.utc(this.audio.currentTime * 1000).format("mm:ss");
    const duration = moment.utc(this.audio.duration * 1000).format("mm:ss");
    this.progressTime.value = `${current} / ${duration}`;
    this.progressRatio.value =
      this.audio.duration > 0
        ? this.audio.currentTime / this.audio.duration
        : 0;
  }

  onEnded() {
    this.pause();
    this.progressRatio.value = 0;
    this.progressTime.value = null;
    this.playing.value = false;
  }
}

export default AudioPlayer;
